import React from 'react';
import autobind from 'autobind-decorator';
import {Col, FormControl, Row} from 'react-bootstrap';

import {BaseTableFilter} from "../../Common/Tables/BaseTableFilter";
import {service as ConservationActionTypeService} from "../../../Services/ConservationActionTypeService";
import {service as SurveyTypeService} from "../../../Services/SurveyTypeService";
import {service as OrganizationService} from "../../../Services/OrganizationService";


export class SurveysTableFilter extends BaseTableFilter {
    constructor(props) {
        super(props);

        this.setInitialState({
            textFilter: "",
            surveyTypes: [],
            conservationActionTypes: [],
            organizations: [],
            organizationId: "",
        });
    }

    @autobind
    loadData() {
        Promise.all([
            SurveyTypeService.Get(),
            ConservationActionTypeService.Get(),
            OrganizationService.Get(),
        ]).then(([surveyTypes, conservationActionTypes, organizations]) => {
            this.setState({
                surveyTypes: surveyTypes.result ?? [],
                conservationActionTypes: conservationActionTypes.result ?? [],
                organizations: organizations.result ?? [],
            });
        });
    }

    @autobind
    getName(obj) {
        let name = "N/A";
        let surveyType = this.state.surveyTypes.find((x) => x.surveyTypeId === obj.surveyTypeId);
        let conservationActionType = this.state.conservationActionTypes.find((x) => x.conservationActionTypeId === obj.conservationActionTypeId);

        if(surveyType && conservationActionType) {
            name = conservationActionType.name + " - " + surveyType.name;
        }

        return name;
    }

    @autobind
    generateFilters() {
        const { textFilter, organizationId } = this.state || {};
        let filters = [];

        if (organizationId != "") {
            filters.push({
                code: 'organizationId',
                isSet: true,
                logic: (x) => x.organizationId == organizationId
            });
        }

        if(textFilter != "") {
            filters.push({
                code: 'textFilter',
                isSet: true,
                logic: (x) => this.getName(x).toUpperCase().includes(this.state.textFilter.toUpperCase())
            });
        }

        this.updateFilters(filters);
    }

    @autobind
    updateOrganizationId(event) {
        this.setState({ organizationId: event.target.value }, _ => this.generateFilters());
    }

    @autobind
    updateTextFilter(event) {
        this.setState({ textFilter: event.target.value }, () => {
            this.generateFilters();
        });
    }

    @autobind
    _render() {
        const { organizations, organizationId, textFilter } = this.state || {};

        return <div>
            <Col md={6} sm={6} xs={12} />
            <Col md={6} sm={6} xs={12}>
                 <Row>
                     <Col xs={6}>
                         {
                             organizations.length > 1 ?
                                 <FormControl
                                     style={{width: '100%'}}
                                     as="select"
                                     placeholder={organizationId === "" ? "Select an Organization" : "Remove Filter"}
                                     value={organizationId}
                                     onChange={this.updateOrganizationId}
                                 >
                                     <option value="" key="">{organizationId === "" ? "Select an Organization" : "Remove Filter"}</option>
                                     {organizations.map((org) =>
                                         <option key={org.organizationId} value={org.organizationId}>{org.name}</option>
                                     )}
                                 </FormControl>
                                 : null
                         }
                     </Col>
                     <Col xs={6}>
                         <FormControl
                             style={{width: '100%'}}
                             type="text"
                             value={textFilter}
                             placeholder="Search Surveys"
                             onChange={this.updateTextFilter}
                         />
                     </Col>
                 </Row>
            </Col>
        </div>;
    }
}
